import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import LoanCalculator from "@/components/LoanCalculator";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import Team from "../pages/Team";
import ContactSection from "../components/ContactSection";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <LoanCalculator />
      <AboutSection />
      <TestimonialsSection />
      <Team />
      <ContactSection />
      <CTASection />
      <Footer />
    </div>
  );
};

export default Index;
